import { colors } from '@sweep-io/sweep-design';
import { TextField } from '@mui/material';

const EditName = ({
  name,
  setName,
  placeholder,
}: {
  name?: string;
  setName: (value: string) => void;
  placeholder?: string;
}) => {
  return (
    <TextField
      value={name}
      autoFocus
      onChange={(event: { target: { value: string } }) => {
        const value = event.target.value;
        setName(value);
      }}
      sx={{
        '& .MuiOutlinedInput-root': {
          '& fieldset': {
            border: 'none',
          },
          '&:hover fieldset': {
            border: 'none',
          },
          '&.Mui-focused fieldset': {
            border: 'none',
          },
        },
      }}
      InputProps={{
        sx: {
          fontSize: '15px',
          fontWeight: 400,
          color: colors.grey[900],
          backgroundColor: 'transparent',
          padding: 0, // remove outer padding
          '& input': {
            padding: 0, // remove inner input padding
          },
          '&.MuiInputBase-root': {
            minHeight: 'unset',
            height: '24px',
          },
          '& input::placeholder, & textarea::placeholder': {
            fontSize: '15px',
            fontWeight: 400,
            color: colors.grey[700],
          },
        },
      }}
      placeholder={placeholder}
    />
  );
};

export default EditName;
